var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchList = function SvgSearchList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 88 88"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#D0D7DE",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6E7780",
    d: "M38 55H28a1 1 0 0 1 0-2h10.099a19.9 19.9 0 0 1 2.036-7H28a1 1 0 0 1 0-2h13a1 1 0 0 1 .27.037A20.1 20.1 0 0 1 49.272 37H28a1 1 0 0 1 0-2h30c11.046 0 20 8.954 20 20a19.94 19.94 0 0 1-6.154 14.432l12.225 12.225a1 1 0 0 1-1.414 1.414L70.332 70.746A19.9 19.9 0 0 1 58 75c-11.046 0-20-8.954-20-20m20 18c9.941 0 18-8.059 18-18s-8.059-18-18-18-18 8.059-18 18 8.059 18 18 18M28 26h32a1 1 0 0 1 0 2H28a1 1 0 0 1 0-2m-7 3a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
  })));
};
export default SvgSearchList;